import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 上传 ")
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "快递管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.addPosition,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "关键字",
          value: _ctx.searches.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onSearch,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          style: {"margin-top":"10px"},
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'icon')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.icon,
                  style: {"with":"50px","height":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该内容?",
                    onConfirm: ($event: any) => (_ctx.onDel(record,1))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible3,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible3) = $event)),
      title: _ctx.title,
      onOk: _ctx.handleOk2,
      width: "20%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.form,
          "label-col": { span: 4 },
          "wrapper-col": { span: 18 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "快递公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入快递公司",
                  value: _ctx.form.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "快递图标" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.fileList,
                  class: "avatar-uploader",
                  headers: _ctx.uploadHeaders,
                  action: _ctx.uploadAction,
                  data: _ctx.uploadFormData,
                  onChange: _ctx.handleChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_icon, { type: "upload" }),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange"]),
                _createElementVNode("img", {
                  src: _ctx.form.poster,
                  style: {"width":"50px","margin-top":"10px"}
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "公司网址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入公司网址",
                  value: _ctx.form.website,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.website) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "快递编码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入快递编码",
                  value: _ctx.form.code,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.code) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "快递100编码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入快递100编码",
                  value: _ctx.form.code100,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.code100) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "快递鸟编码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入快递鸟编码",
                  value: _ctx.form.codebird,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.codebird) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入排序",
                  value: _ctx.form.sort,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.sort) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ]))
}